// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1-urb","modalCard":"_2dED-"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Account/children/AccountProfile/components/CompletedProfileDialog/modalTheme.scss
// module id = 884
// module chunks = 34